import compact from "lodash/compact";
import { Flex } from "PFComponents/containers";
import { Typography } from "PFComponents/typography";
import useIsFeatureEnabled from "PFCore/helpers/use_is_feature_enabled";
import { useDateFormatter } from "PFCore/hooks";
import { usePhases } from "PFCore/hooks/queries/phases/use_phases";
import { AvailabilityMode, FeatureFlag, StandardRange } from "PFTypes";
import { useTranslation } from "react-i18next";

import {
  getDurationText,
  getFormattedRangeDates,
  getRangePhaseText
} from "../../readable_availability_rules.utils";

type ReadableStandardRangeProps = {
  range: StandardRange;
  mode: AvailabilityMode;
  multiline: boolean;
};

export const ReadableStandardRange = ({ range, mode, multiline }: ReadableStandardRangeProps) => {
  const { t } = useTranslation(["core", "translation"]);
  const { formatDate } = useDateFormatter();
  const hasActivityPhases = useIsFeatureEnabled(FeatureFlag.ActivityPhases);

  const { data: phases } = usePhases(null, {
    enabled: hasActivityPhases,
    placeholderData: { entries: [], meta: { total: 0 } }
  });

  const phase = getRangePhaseText(phases?.entries || [], range);
  const dateRange = getFormattedRangeDates(range, formatDate);

  const phaseWithDateRange = compact([phase, dateRange]).join(": ");
  const details = `(${getDurationText(range.duration, mode, t)})`;

  return (
    <Flex direction={multiline ? "column" : "row"} gap="spacingSm">
      <Typography variant="bodyRegular">{phaseWithDateRange}</Typography>
      <Typography variant="labelRegular">{details}</Typography>
    </Flex>
  );
};
